<script setup>
const gsapTimeline = useGsapTimeline()
const emit = defineEmits(['timeline', 'disappearTimeline'])

const wrapper = ref(null)
const cover = ref(null)

onMounted(() => {
  const timeline = gsapTimeline({ name: 'SquareMask' })
    .fromTo(wrapper.value, { scale: 0, transformOrigin: 'bottom left' }, { scale: 1, duration: 0.4, ease: 'power3.inOut' })
    .fromTo(cover.value, { scale: 1, transformOrigin: 'top right' }, { scale: 0, duration: 0.4, ease: 'power3.inOut' }, '>')

  emit('timeline', timeline)

  emit('disappearTimeline', () => {
    return gsapTimeline({ name: 'SquareMask - Disappear' })
      .fromTo(cover.value, { scale: 0, transformOrigin: 'top right' }, { scale: 1, duration: 0.4, ease: 'power3.inOut' })
      .fromTo(wrapper.value, { scale: 1, transformOrigin: 'bottom left' }, { scale: 0, duration: 0.4, ease: 'power3.inOut' }, '>')
  })
})
</script>

<template>
  <div>
    <div ref="wrapper" class="relative mask aspect-square">
      <div ref="cover" class="bg-willy-cr-black-primary inset-0 absolute" />
      <slot />
    </div>
  </div>
</template>

<style scoped>
.mask {
  mask-image: url('../masks/willy-mask-square.svg');
}
</style>
